import * as React from 'react'
import {Dialog, DialogBody, DialogHeading} from '@frontrow/console/src/components/ui/dialog'
// CComponents
import {Button} from '@frontrow/console/src/components/button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch} from '@fortawesome/free-solid-svg-icons'

// Models
import {type TeacherWithAffiliationT} from '@frontrow/console/src/models/teacher'
// Components
import TeacherInformation from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/teacher-information'
import SchoolInformation from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/school-information'
import DistrictInformation from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/district-information'
import {FIELD_GRID} from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/field'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  teacherData: TeacherWithAffiliationT
}

// Teacher, School and District are peers, so they share one heading level.
// The H2 this replaces carried 16px margins of its own.
const GROUP_HEADING = 'text-[13px] font-semibold text-heading border-b border-border pb-1 mb-2'

export default function TeacherInformationButtonModal({teacherData}: Props): React.ReactElement {
  const changeMadeRef = React.useRef(false)
  const {isOpen, open, close: baseClose} = useModalForm()

  const handleClose = () => {
    if (changeMadeRef.current) {
      window.location.reload()
    }
    baseClose()
  }

  const {teacher, school, district} = teacherData

  const schoolInformationNode =
    school !== null && school !== undefined ? <SchoolInformation school={school} /> : 'None'

  const districtInformationNode =
    district !== null && district !== undefined ? (
      <DistrictInformation district={district} />
    ) : (
      'None'
    )

  return (
    <React.Fragment>
      <Button
        title="Teacher Information"
        dataTest="teacher-information-button"
        onClick={open}
        style="link"
      >
        <FontAwesomeIcon icon={faSearch} />
      </Button>

      <Dialog open={isOpen} onClose={handleClose} size="lg">
        <DialogHeading>
          Teacher Information: {teacher.firstName} {teacher.lastName}
        </DialogHeading>
        <DialogBody>
          <section>
            <h2 className={GROUP_HEADING}>Teacher</h2>
            <TeacherInformation
              teacher={teacher}
              onChange={() => {
                changeMadeRef.current = true
              }}
            />
          </section>
          {/* School and District are siblings under the teacher, so they sit
              side by side. Two columns each of the same four-column grid the
              Teacher fields use, so every value lines up down the modal. */}
          <div className={`mt-5 ${FIELD_GRID}`}>
            <section className="col-span-2">
              <h2 className={GROUP_HEADING}>School</h2>
              {schoolInformationNode}
            </section>
            <section className="col-span-2">
              <h2 className={GROUP_HEADING}>District</h2>
              {districtInformationNode}
            </section>
          </div>
        </DialogBody>
      </Dialog>
    </React.Fragment>
  )
}
